import React from 'react'

const IconCanvasOpen = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <rect x='3' y='3' width='18' height='18' rx='2' />
         <path d='M3 15l5-5 4 4 5-6 4 5' />
      </svg>
   )
}
export default IconCanvasOpen
